/**
 * @generated SignedSource<<784d708b6e688e6b2f981089ca8db631>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type RepositoryVisibility = "INTERNAL" | "PRIVATE" | "PUBLIC" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type IssueCommentComposer$data = {
  readonly databaseId: number | null;
  readonly id: string;
  readonly locked: boolean;
  readonly repository: {
    readonly databaseId: number | null;
    readonly id: string;
    readonly isArchived: boolean;
    readonly nameWithOwner: string;
    readonly slashCommandsEnabled: boolean;
    readonly visibility: RepositoryVisibility;
  };
  readonly viewerCanClose: boolean;
  readonly viewerCanComment: boolean;
  readonly viewerCanReopen: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"IssueActions">;
  readonly " $fragmentType": "IssueCommentComposer";
};
export type IssueCommentComposer$key = {
  readonly " $data"?: IssueCommentComposer$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueCommentComposer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IssueCommentComposer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "locked",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanComment",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanClose",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanReopen",
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Repository",
      "kind": "LinkedField",
      "name": "repository",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isArchived",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nameWithOwner",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slashCommandsEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "visibility",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "IssueActions"
    }
  ],
  "type": "Issue",
  "abstractKey": null
};
})();

(node as any).hash = "775df1159479779b88ef214a8dec4d85";

export default node;
